<template>
  <div class="design-text">
    <div class="design-side">
    <div
      v-for="(textDesignFromList, index) in this.uStore.userDesigns[
        store.currentEditingProps.productId
      ].designs[store.currentEditingProps.variantId].imgVariants[store.currentEditingProps.imageToPreview]
        .texts"
      :key="index"
      class="elements-container"
    >
        <div :class="store.currentEditingProps.currentPreview == 'text' && store.currentEditingProps.currentPreviewIndex == index ? 'element-div ele-div-active' : 'element-div'">

          <div class="element-line-1">
              <div class="ele-title-line">
                <span class="ele-title">
                  <span class="ele-title-txt">Enter Text</span>
                </span>
                <span class="remove-container" @click.stop="delText(index)">
                  <img class="remove-img" src="../../../public/Icons-DeleteBlackIcon.png"/>
                  <span class="remove-title">Remove</span>
                </span>
              </div>
              {{ store.allFonts.value[textDesignFromList.fontID].isRtl }}
              <span class="ele-input-container">
                <input class="ele-input " v-if="!store.allFonts.value[textDesignFromList.fontID].isRtl" placeholder="Write Your Text.." type="text"
                v-model="
               uStore.userDesigns[store.currentEditingProps.productId].designs[
                  store.currentEditingProps.variantId
                ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                ].text
                "
              @input="filterInput($event,index)" />

              <input v-else class="ele-input hebrew" placeholder="הכנס טקסט..." type="text"
                v-model="
               uStore.userDesigns[store.currentEditingProps.productId].designs[
                  store.currentEditingProps.variantId
                ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                ].text
                "
              @input="filterInput($event,index)"
              />
              
              <span class="change-size-container">
                <span @click="increaseSize(index)" style="cursor: pointer;">+</span>
                <span>
                  <svg width="17" height="10" viewBox="0 0 17 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.846 7.83H2.59L1.806 10H0.462L3.99 0.298H5.46L8.974 10H7.63L6.846 7.83ZM6.482 6.794L4.718 1.866L2.954 6.794H6.482ZM14.8126 8.295H11.4686L10.8526 10H9.79659L12.5686 2.377H13.7236L16.4846 10H15.4286L14.8126 8.295ZM14.5266 7.481L13.1406 3.609L11.7546 7.481H14.5266Z" fill="#2D2D2D"/>
                  </svg>
                </span>
                <span @click="decreaseSize(index)" style="cursor: pointer;">-</span>
              </span>
            </span>
            <span v-if="showInputTextError[index]" class="input-text-error">Character not available on font</span>
          </div>
          <div class="element-line-2">
            <div class="form-outline propLine">
              <label class="lableInOpenLine">Font</label>
              <vue-select
                class="form-control openLineInput font-selected"
                :close-on-select="true"
                :min="1"
                :options="store.getAllFontsWithoutMaterials()"
                label-by="fontName"
                value-by="fontID"
                searchable
                :model-value="
                 uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                    index
                  ].fontID
                "
                @update:modelValue="
                  (value) => {
                    if (value !== null && value !== undefined) {
                     uStore.userDesigns[store.currentEditingProps.productId].designs[
                        store.currentEditingProps.variantId
                      ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                        index
                      ].fontID = value;
                      updateFont(index);
                    }
                  }
                "
              >
                <template #label="{ selected }">
                  <template v-if="selected">
                    <div class="font-txt-preview">
                      <span class="txt-preview-comp" :style="{'width': ((store.getTextLength(selected.fontName, selected.fontID, Object.values(store.allFonts.value[selected.fontID].sizes)[0].sizeID) * store.currentEditingProps.dpi) / 254.0) + 'px'}">
                      <TextPreview
                        :IDFontToPreview="selected.fontID"
                        :IDSizeFontToPreview="Object.values(store.allFonts.value[selected.fontID].sizes)[0].sizeID"
                        :TextToPreview="selected.fontName"
                        :dpi="
                          (28.0 / store.allFonts.value[selected.fontID].sizes[Object.values(store.allFonts.value[selected.fontID].sizes)[0].sizeID].FontHeight) *
                          254.0
                        "
                        superPos="normal"
                        :layersColors="[store.blackColorIdDst]"
                        :x="0"
                        :y="0"
                      >
                      </TextPreview>
                    </span>
                    </div>
                  </template>
                  <template v-else>
                    <div class="font-txt-preview">
                      <span class="txt-preview-comp" :style="{'width': (((store.getTextLength(Object.values(store.allFonts.value)[0].fontName, store.getAllFontsWithoutMaterials()[0].fontID, Object.values(store.getAllFontsWithoutMaterials()[0].sizes)[0].sizeID)) * store.currentEditingProps.dpi) / 254.0) + 'px'}">
                      <TextPreview
                        :IDFontToPreview="store.getAllFontsWithoutMaterials()[0].fontID"
                        :IDSizeFontToPreview="Object.values(store.getAllFontsWithoutMaterials()[0].sizes)[0].sizeID"
                        :TextToPreview="store.getAllFontsWithoutMaterials()[0].fontName"
                        :dpi="
                          (28.0 / store.getAllFontsWithoutMaterials()[0].sizes[Object.values(store.getAllFontsWithoutMaterials()[0].sizes)[0].sizeID].FontHeight) *
                          254.0
                        "
                        superPos="normal"
                        :layersColors="[store.blackColorIdDst]"
                        :x="0"
                        :y="0"
                      >
                      </TextPreview>
                    </span>
                    </div>
                  </template>
                </template>
                <template #dropdown-item="{ option }">
                  <div class="font-txt-preview">
                      <span class="txt-preview-comp" :style="{'width': (((store.getTextLength(option.fontName, option.fontID, Object.values(store.allFonts.value[option.fontID].sizes)[0].sizeID)) * store.currentEditingProps.dpi) / 254.0) + 'px'}">
                    <TextPreview
                        :IDFontToPreview="option.fontID"
                        :IDSizeFontToPreview="Object.values(store.allFonts.value[option.fontID].sizes)[0].sizeID"
                        :TextToPreview=option.fontName
                        :dpi="
                          (28.0 / store.allFonts.value[option.fontID].sizes[Object.values(store.allFonts.value[option.fontID].sizes)[0].sizeID].FontHeight) *
                          254.0
                        "
                        superPos="normal"
                        :layersColors="[store.blackColorIdDst]"
                        :x="0"
                        :y="0"
                      >
                      </TextPreview>
                    </span>
                  </div>
                </template>
              </vue-select>
            </div>

            <div class="form-outline propLine" style="width: unset;">
              <label class="lableInOpenLine">Color</label>
              <div class="font-layers-colors-container">
                <template v-for="(layerColorID, colorIndex) in uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                  ].layersColors" :key="colorIndex">
                    <SelectColor v-model="uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                      index
                  ].layersColors[colorIndex]"></SelectColor>
                </template>
              </div>                      
            </div>

            <div class="form-outline propLine">
              <label class="lableInOpenLine" style="display: flex; align-items: flex-end;"
                ><span>Arc </span>&nbsp;
                <span style="font-size: 12px;">{{
                 uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                  ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                  index
                  ].textArc
                }}°</span>&nbsp;
              </label>
              <div class="form-control" style="display: flex; gap: 5px;">                        
                <span class="reset-arc" title="Reset Arc"
                    @click="resetArc('text', index)">                          
                <img
                  :src="store.baseIconsURL + '//Icons-ResetArcIcon.png'"
                  style="height: 7px;"
                />
                </span>
                <MDBRange
                  class="form-range"
                  :min="-180"
                  :max="180"
                  v-model="
                   uStore.userDesigns[store.currentEditingProps.productId].designs[
                    store.currentEditingProps.variantId
                    ].imgVariants[store.currentEditingProps.imageToPreview].texts[
                    index
                    ].textArc
                  "
                  @change="changeArc('text', index)"
                />
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
      <span class="btn-add-element" title="Add New Text"  @click="addTextToDesign()">
        + Add New Text
      </span>
  </div>
</div>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import { userStore } from "@/stores/userStore";
import VueSelect from "vue-next-select";
import TextPreview from "../TextPreview.vue";
import SelectColor from "../SelectColor.vue";
import {
MDBRange,
} from "mdb-vue-ui-kit";


export default {
  components: {
      TextPreview,
      SelectColor,
      MDBRange,
      VueSelect,
  },
  setup() {
      const store = designerStore();
      const uStore = userStore();
      return {
          store,
          uStore,
      };
  },
  data() {
    return {
      showInputTextError: []
    }
  },
  props: {
      changeStyleByRef: {
          type: Function,
          required: true
      },
      increaseTextSize: {
          type: Function,
          required: true
      },
      decreaseTextSize: {
          type: Function,
          required: true
      },
      changeArc: {
          type: Function,
          required: true
      },
      resetArc: {
          type: Function,
          required: true
      },
  },
  // async mounted() {
   
  // props: ["textPreview", "imageToPreview", "productId", "variantId", "currentPreviewIndex", "currentPreview", "dpi"],
  // },
  methods: {
    async increaseSize(index) {
          console.log('DesignText: increaseSize called with index:', index);
          this.store.currentEditingProps.currentPreviewIndex = index;
          await this.increaseTextSize(index);
      },
      async decreaseSize(index) {
          console.log('DesignText: decreaseSize called with index:', index);
          this.store.currentEditingProps.currentPreviewIndex = index;
          await this.decreaseTextSize(index);
      },
    async addTextToDesign() {
      var fontObj = this.store.getAllFontsWithoutMaterials()[0];
      (this.store.currentEditingProps.textPreview = {
          imageName: this.store.currentEditingProps.imageToPreview,
          text: "",
          fontID: fontObj.fontID,
          fontSizeID: Object.values(this.store.getAllFontSizes(fontObj.fontID))[0].sizeID,
          layersColors: [...fontObj.defaultFontColors] || this.store.getDefaultColorArray(fontObj.layerCount || 1),
          //colorID: this.store.blackColorIdDst,
          textArc: 0,
          location: { x: 0, y: 0, arc: 0 },
      }),
          this.store.addTextToDesign(
          this.store.currentEditingProps.productId,
          this.store.currentEditingProps.variantId,
          this.store.currentEditingProps.textPreview
          );
      this.store.currentEditingProps.currentPreviewIndex =
          this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
          .imgVariants[this.store.currentEditingProps.imageToPreview].texts.length - 1;
      this.store.currentEditingProps.currentPreview = "text";
      await this.changeStyleByRef('text');
    },
    delAllTexts() {
      this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        this.store.currentEditingProps.variantId
      ].imgVariants[this.store.currentEditingProps.imageToPreview].texts = [];
      this.store.currentEditingProps.currentPreviewIndex = -1;
    },
    openElement(type, index) {
      this.store.currentEditingProps.currentPreviewIndex = this.store.currentEditingProps.currentPreviewIndex == index ? -1 : index;
      this.store.currentEditingProps.currentPreview = type;
      this.store.currentEditingProps.changeSelectedArt = false;
      this.store.currentEditingProps.changeSelectedMonogram = false;
      // this.newMonogram = this.newMonogram == null ? null : 0;
      this.store.currentEditingProps.newArt = (this.store.currentEditingProps.newArt == true || this.store.currentEditingProps.newArt == false) ? false : null;
      this.store.currentEditingProps.newMonogram = (this.store.currentEditingProps.newMonogram == true || this.store.currentEditingProps.newMonogram == false) ? false : null;
    },
    filterInput(event, index) {
  const textObj = this.uStore.userDesigns[this.store.currentEditingProps.productId]
    .designs[this.store.currentEditingProps.variantId]
    .imgVariants[this.store.currentEditingProps.imageToPreview]
    .texts[index];
    this.fixTextToFont(textObj, index);
    event.target.value = textObj.text;
  const fontID = textObj.fontID;
  // const allowedCharsObj = this.store.allFonts.value[fontID].sizes["1"].DictCharacters;
  // const allowedChars = Object.keys(allowedCharsObj);

  // const input = event.target.value;
  // let result = '';
  // let hasInvalidChar = false;

  // for (let char of input) {
  //   if (allowedChars.includes(char)) {
  //     result += char;
  //   } else {
  //     const altChar = char === char.toLowerCase()
  //       ? char.toUpperCase()
  //       : char.toLowerCase();

  //     if (allowedChars.includes(altChar)) {
  //       result += altChar;
  //     } else {
  //       hasInvalidChar = true;
  //     }
  //   }
  // }

  // event.target.value = result;
  // textObj.text = result;
  // this.showInputTextError = hasInvalidChar;
  // setTimeout(() => {
  // this.showInputTextError = false;
  // }, 2000);

  if (this.store.allFonts.value[fontID].isRtl === true) {
    // if (fontID === 7) {
    this.reverseText(index);
  }

  this.updateTextLocation(index);
},
fixTextToFont(textObj, index) {
  // const textObj = this.uStore.userDesigns[this.store.currentEditingProps.productId]
  //   .designs[this.store.currentEditingProps.variantId]
  //   .imgVariants[this.store.currentEditingProps.imageToPreview]
  //   .texts[index];

  const fontID = textObj.fontID;
  const fontSizeID = textObj.fontSizeID;
  const allowedCharsObj = this.store.allFonts.value[fontID].sizes[fontSizeID].DictCharacters;
  const allowedChars = Object.keys(allowedCharsObj);

  const input = textObj.text; //event.target.value;
  let result = '';
  let hasInvalidChar = false;

  for (let char of input) {
    if (allowedChars.includes(char)) {
      result += char;
    } else {
      const altChar = char === char.toLowerCase()
        ? char.toUpperCase()
        : char.toLowerCase();

      if (allowedChars.includes(altChar)) {
        result += altChar;
      } else {
        hasInvalidChar = true;
      }
    }
  }
  this.showInputTextError[index] = hasInvalidChar;
  setTimeout(() => {
  this.showInputTextError[index] = false;
  }, 2000);
  textObj.text = result;
},
async reverseText(index) {
  let text = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
    this.store.currentEditingProps.variantId
  ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[index].text;
  if (text.length > 0) {
    let lastChar = text[text.length - 1];
    text = lastChar + text.slice(0, -1);
  }
  this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
    this.store.currentEditingProps.variantId
  ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[index].text = text;
},
    async updateTextLocation(index) {
      // this.store.movInd++;
      var textObj =
        this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[this.store.currentEditingProps.variantId]
          .imgVariants[this.store.currentEditingProps.imageToPreview].texts[index];
          // this.
          // (textObj);


        this.store.updateTextLocation(
          this.store.currentEditingProps.productId,
          this.store.currentEditingProps.variantId,
          this.store.currentEditingProps.imageToPreview,
          index,
          textObj.text,
          textObj.dragLocation.x,
          textObj.dragLocation.y,
          textObj.textArc,
          textObj.fontID,
          textObj.fontSizeID
        );

        // ----------
        // הורדתי את השורות הללו כי שמתי אותם בפונקציה שבסטור כדי שיתייחס לזוויות
        // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index].dragTransform.width = this.store.getTextLength(textObj.text, textObj.fontID, textObj.fontSizeID) *
        //   // textObj.dragTransform.scale.scaleX * 
        //   this.store.currentEditingProps.dpi / 254;

        //   this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index].dragTransform.height = this.store.getMaxTextHeight(textObj.text, textObj.fontID, textObj.fontSizeID) *
        //     // textObj.dragTransform.scale.scaleY * 
        //     this.store.currentEditingProps.dpi / 254;
        // --------------

         

      //הקוד הישן של עדכון גובה ורוחב
        // this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index
        //   ].dragTransform.width = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index
        //   ].dragSize.w; // * this.store.currentEditingProps.dpi) / 254;
        //   this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index
        //   ].dragTransform.height = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
        //   this.store.currentEditingProps.variantId
        //   ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
        //   index
        //   ].dragSize.h; // * this.store.currentEditingProps.dpi) / 254;



          await this.changeStyleByRef('text');
        // this.boxKey++;
      // }
    },
    updateTextLayersColors(textObjFromStore) {
      //בשינוי פונט - בודק כמה שכבות של צבעים שמורות בסטור
      //בודק כמה שכבות צריך בשביל הפונט החדש לפי האות שהוקלדה
      //מחסיר או מוסיף צבע לרשימת הצבעים בסטור
      //כל פעם יכול להיות שתוקלד אות עם צבע אחד יותר
      var currentLayers = textObjFromStore.layersColors.length;
      var maxLettersLayers =
      Math.max(...Object.values(textObjFromStore.text).map(m => this.store.allFonts.value[textObjFromStore.fontID].sizes[textObjFromStore.fontSizeID]
            .DictCharacters[m].dstfile.layerCount));
      console.log('currentLayers = ', currentLayers);
      console.log('maxLettersLayers = ', maxLettersLayers);
     
      // this.store.allFonts.value[textObjFromStore.fontID].sizes[textObjFromStore.fontSizeID]
      //       .DictCharacters[textObjFromStore.text[textObjFromStore.text.length-1]].dstfile.layerCount;

      if(currentLayers < maxLettersLayers) { //אם חסרות שכבות בסטור - מוסיף את מספר השכבות הזה
        this.addColorLayer(textObjFromStore, maxLettersLayers - currentLayers);
      } else if (currentLayers > maxLettersLayers) { //אם יש יותר מידי שכבות בסטור - מוחק מה שצריך
        this.removeColorLayer(textObjFromStore, currentLayers - maxLettersLayers);
      }
    },
    delText(index) {
      this.store.delText(
        this.store.currentEditingProps.productId,
        this.store.currentEditingProps.variantId,
        this.store.currentEditingProps.imageToPreview,
        index
      );
      this.store.currentEditingProps.currentPreviewIndex = -1;
      // this.currentPreview = "";
    },
    addColorLayer(textObjFromStore, sumMissLayers) {
      var listColorsToAdd = this.store.getAllColors().slice(textObjFromStore.layersColors.length - 1, sumMissLayers).map(m => m.colorID);
      listColorsToAdd.forEach(colorID => {
        textObjFromStore.layersColors.push(colorID);
      });
    },
    removeColorLayer(textObjFromStore, sumLayersToRemove) {
      textObjFromStore.layersColors.splice(textObjFromStore.layersColors.length - sumLayersToRemove, sumLayersToRemove);
    },
    updateFont(currentPreviewIndex) {
      let textObj = this.uStore.userDesigns[this.store.currentEditingProps.productId].designs[
      this.store.currentEditingProps.variantId
                      ].imgVariants[this.store.currentEditingProps.imageToPreview].texts[
                        currentPreviewIndex
                      ];
      textObj.fontSizeID =
          Object.values(this.store.getAllFontSizes(textObj.fontID))[0].sizeID;
      this.fixTextToFont(textObj, currentPreviewIndex);
          // this.store.allFonts.value[
          //   this.uStore.userDesigns[this.productId].designs[this.variantId]
          //     .imgVariants[this.imageToPreview].texts[currentPreviewIndex]
          //     .fontID
          // ].sizes

          //פונקציה מצוינת שמעדכנת מספר שכבות, מוסיפה או מוחקת צבעים מהטקסט
          //לא משתמשים כי הוספנו שמירת צבעים דיפולטיביים, נזמן את הישנה אם אין הגדרה של צבעים לפונט
          // this.updateTextLayersColors(textObj);
          var fontObj = this.store.allFonts.value[textObj.fontID];
           if(fontObj.defaultFontColors == undefined || fontObj.defaultFontColors.length == 0) {
            this.updateTextLayersColors(textObj);
          }
           else {
            textObj.layersColors = fontObj.defaultFontColors;
          }
        
      this.updateTextLocation(currentPreviewIndex);
    },
  }
};
</script>

<style>


.vue-input{
      background: transparent !important; /* מבטל רקע */
  border: none !important; /* מבטל מסגרת */
  box-shadow: none !important; /* מבטל הצללה */
  outline: none; /* מבטל קו פוקוס כחול */
}
.range{
  width: 100%;
  box-sizing: border-box; /* כדי שיכלול גם padding/border בחישוב */
}
.form-outline.propLine{
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    align-items: baseline;
    justify-content: flex-end;

}

.form-range{
    width: 100%;
  box-sizing: border-box; /* כדי שיכלול גם padding/border בחישוב */
    display: flex;
    align-items: flex-end;
}
.arrow-downward.active {
  border: none;
  width: 14px;
  height: 14px;
  background-size: contain;
  background-position: center;
  background-image: url("https://embgift.myshopify.com/cdn/shop/t/5/assets//Icons-CloseIconBlack.png");
}
.arrow-downward{
  background-size: contain;
  background-position: center;
  width: 14px;
  height: 14px;
  border: none;
  background-image: url("https://embgift.myshopify.com/cdn/shop/t/5/assets//Icons-OpenIconBlack.png");
}
</style>
<style scoped>

.font-layers-colors-container{
  display: flex;
}
.openLine {
  display: grid;
}
.elements-container {
margin-bottom: 8px;
}
.element-line-2 {
  display: flex;
  gap: 15px;
}


input.ele-search-input {
  border: 1px solid #D9D9D9;
  border-radius: 4px 0px 0px 4px;
  padding: 3px 6px;
  font-size: 12px;
}
.item-line {
  display: flex;
  justify-content: space-between;
}
span.floatRight {
  display: flex;
  gap: 22px;
  margin-right: 6px;
  margin-bottom: 3px;
}

.ele-input::placeholder{
color: rgba(186, 186, 186, 1);
}
.element-div{
color: rgba(45, 45, 45, 1);
}
.input-text-error {
  color: red;
  font-size: 13px;
}
.hebrew {
direction: rtl; /* יישור הטקסט מימין לשמאל */
text-align: right; /* יישור פיזי של הטקסט לצד ימין */
}

.vue-dropdown-item {
    padding: 10px 0 !important;
    margin: 0;
}
</style>